"use client";
import React, { useId } from "react";
import Slider from "@/components/Slider";
import { ProductJson } from "@/types/Product.type";
import ProductCard from "~components/product/ProductCard";
import useTranslationApi from "@/lib/hooks/useTranslationApi";
import Carousel from "@/components/Carousel";
import { SlideNextIcon, SlidePrevIcon } from "@/components/icons";
import { useAppSelector } from "@/redux/hook";
import { selectDevice } from "@/redux/features/ShopSlice";

type Props = {
	data: ProductJson[];
	className?: string;
};

export default function ProductRelatedList({ data, className }: Props) {
	const { t } = useTranslationApi(["product_related"]);
	const device = useAppSelector(selectDevice);

	const handleRender = (item: ProductJson) => {
		return <ProductCard key={item.id} data={item} />;
	};
	return (
		<div className={className}>
			<h2 className="text-base md:text-4xl text-gray-500 mb-3 md:mb-8 px-4 md:px-0 font-semibold md:font-normal font-sans">
				{t("product_related")}
			</h2>
			<Carousel
				device={device}
				data={data}
				itemSlider={handleRender}
				navigation={true}
				breakpoints={{
					0: { slidesPerView: 2, spaceBetween: 0 },
					375: { slidesPerView: 2, spaceBetween: 0 },
					414: { slidesPerView: 2, spaceBetween: 0 },
					640: { slidesPerView: 2, spaceBetween: 0 },
					768: { slidesPerView: 4, spaceBetween: 0 },
					1024: { slidesPerView: 6, spaceBetween: 0 },
					1200: { slidesPerView: 6, spaceBetween: 0 },
				}}
				loop={true}
				centeredSlides={{ desktop: false, mobile: true }}
				// classNameItemRender="first:ml-4 last:mr-4 md:first:ml-0 md:last:mr-0"
				navigationButton={{
					iconNext: <SlideNextIcon className="mt-[-60px]" />,
					iconPrev: <SlidePrevIcon className="mt-[-60px]" />,
				}}
			/>
		</div>
	);
}
